import { createContext, useContext, useState } from 'react';

import Metrics from '@spotahome/soyuz-tracking';

import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { clientErrorTracker } from '@spotahome/soyuz/client';

import getGqlClient from '../clients/graphql/marketplace';
import { trackListingShare } from '../mutations/shared';

const ShareContext = createContext({
  shareCount: 0,
  incrementShare: () => {}
});

export const ShareProvider = ({ listingId, sharesCount, children }) => {
  const [shareCount, setShareCount] = useState(sharesCount);

  const incrementShare = async eventMethod => {
    if (!listingId) {
      console.error('Can not increment share count without a listing id');
      return;
    }
    SoyuzAnalytics.sendGA4Event('share', {
      method: eventMethod,
      content_type: 'url',
      item_id: listingId
    });
    Metrics.actions.sendActionEvent(Metrics.actions.SHARE_LISTING, {
      listingId
    });

    setShareCount(prev => prev + 1);

    try {
      await trackListingShare(getGqlClient())(listingId);
    } catch (error) {
      clientErrorTracker.error({
        error,
        source: `ListingShare-${eventMethod}`
      });
    }
  };
  return (
    <ShareContext.Provider value={{ shareCount, incrementShare }}>
      {children}
    </ShareContext.Provider>
  );
};

export const useShare = () => useContext(ShareContext);

export default {
  ShareProvider,
  useShare
};
